<template>
  <div class="sidebarWrapper">

    <div class="pageList">
      <div :class="[isCurrentPage(page.extname) ? 'selectedPageRow' : 'pageRow']" v-bind:key="page.extname" v-for="page in pages">
        <a @click="onPageSelected(page)">
          <v-icon v-b-tooltip.hover :title="$tmap(page.title)" :name="page.icon" scale="2"></v-icon>
          <span class="pageName" v-if="expanded">{{ $tmap(page.title) }}</span>
        </a>
      </div>

      <div :class="[isReportPage() ? 'selectedPageRow' : 'pageRow']">
        <a @click="onReportsSelected">
          <v-icon v-b-tooltip.hover width="32" :title="$t('REPORTS')" name="file-alt" scale="2"></v-icon>
          <span class="pageName" v-if="expanded">{{'REPORTS' | i18n}}</span>
        </a>
      </div>

    </div>



  </div>
</template>

<script>
import {mapGetters} from "vuex";
import PageNavigator from "../services/PageNavigator";

export default {
  name: 'NavSidebar',

  props: {
    expanded: Boolean
  },

  computed: {
    ...mapGetters(['pages', 'completePath', 'studyName']),

    tmap(text) {
      return this.$tmap(text)
    }

  },

  methods: {
    isReportPage() {
      return PageNavigator.isOnReportsPage(this.$router)
    },

    onReportsSelected() {
      PageNavigator.navigateToReportsPage(this.$router, this.studyName)
    },

    onPageSelected(page) {
      PageNavigator.navigateToPage(this.$router, page.extname, this.completePath)
    },

    isCurrentPage(pageName) {
      if(this.$route.name === 'seite') {
        return pageName === this.$route.params.pageName;
      }
      return false
    }


  }





}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebarWrapper {
  background: #757575;
  color: white;
  padding-left: 1em;
}

div.pageRow {
  display: flex;
  flex-direction: row;
  margin-bottom: 1em;
  align-items: center;
}

div.selectedPageRow {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-bottom: 1em;
  align-items: center;
  color: #50bcff;
}


div.pageRow:hover {
  color: #50bcff;
  cursor: pointer;
}

span.pageName {
  /*color: white;*/
  font-size: 120%;
  font-weight: bold;
  margin-left: 1em;
}


</style>
